import { keyBy } from "lodash";

import { Action } from "../../store/types";
import { Product } from "../../models";
import * as actions from "./actions";

export interface ProductCarouselState {
  products: { [id: number]: Product };
}

const initialState: ProductCarouselState = {
  products: {},
};

export default function(
  state = initialState,
  { type, payload }: Action,
): ProductCarouselState {
  switch (type) {
    case actions.RELOAD_FEATURED:
      return {
        ...state,
        products: {
          ...state.products,
          ...keyBy<Product>(payload, product => product.id),
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/reducer.ts